import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { useAdsTable } from '../_tables/AdsTable/hooks/useAdsTable'
import { cpcPatch, cpmPatch } from '../../store/industry/ad/actions'

const actions = {
  cpc: cpcPatch,
  cpm: cpmPatch
}

interface UseEditBudgetProps {
  type: 'cpc' | 'cpm'
  id: string
  setLocalLoading?: (loading: boolean) => void
  handleSuccess?: () => void
}

export function useEditBudget({
  type,
  id,
  setLocalLoading,
  handleSuccess
}: UseEditBudgetProps) {
  const { handleMutate } = useAdsTable()
  const dispatch = useDispatch()

  const handleEditRequest = useCallback(
    (
      cost: number | null,
      origin?: { source: 'bid_monitor'; suggestedValue: number }
    ) => {
      setLocalLoading?.(true)

      const action = actions[type]
      const originFields = origin
        ? { source: origin.source, suggested_value: origin.suggestedValue }
        : {}

      const onSuccess = () => {
        handleMutate()
        handleSuccess?.()
        setLocalLoading?.(false)
      }
      const onError = () => setLocalLoading?.(false)

      if (type === 'cpc') {
        dispatch(
          action({
            body: { cpc: cost, ...originFields },
            id,
            onSuccess,
            onError
          })
        )
        return
      }

      dispatch(
        action({
          body: { cpm: cost, ...originFields },
          id,
          onSuccess,
          onError
        })
      )
    },
    [id, dispatch, handleMutate, handleSuccess, setLocalLoading, type]
  )

  return { handleEditRequest }
}
